import "babel-polyfill"; // 兼容ie9+
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import ZkTable from 'vue-table-with-tree-grid'
Vue.use(ZkTable)

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import VueScroller from "vue-scroller";
Vue.use(VueScroller);

import $ from "jquery";
window.$ = $;

import VueQriously from "vue-qriously";
Vue.use(VueQriously);

import WebsocketHeartbeatJs from 'websocket-heartbeat-js';
window.WebsocketHeartbeatJs = WebsocketHeartbeatJs

import ReconnectingWebSocket from 'reconnecting-websocket';
window.ReconnectingWebSocket = ReconnectingWebSocket

// import Danmaku from 'danmaku/dist/danmaku.modi.js';
// window.Danmaku = Danmaku;

import "notyf/dist/notyf.min.js";
import "notyf/dist/notyf.min.css";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "../static/bootstrap-table/bootstrap-table.min"
import "../static/bootstrap-table/bootstrap-table.css";

// import 'bootstrap-table/dist/locale/bootstrap-table-zh-CN'

import "../static/bootstrap-table/extensions/export/bootstrap-table-export.min"

import "../static/bootstrap-table/extensions/page-jump-to/bootstrap-table-page-jump-to.min.js";
import "../static/bootstrap-table/extensions/page-jump-to/bootstrap-table-page-jump-to.css";


// import "bootstrap-table/dist/extensions/treegrid/bootstrap-table-treegrid"

import "../static/bootstrap-table/extensions/treegrid/bootstrap-table-treegrid.min"

import "jquery-treegrid/js/jquery.treegrid.min";
import "jquery-treegrid/css/jquery.treegrid.css";

import "tableexport.jquery.plugin";

import "jqPaginator/dist/1.2.0/jqPaginator.min.js";

import "jquery-form";

import "jquery-validation";

// import './assets/bootstrap-table-fixed-columns-master/bootstrap-table-fixed-columns'
// import './assets/bootstrap-table-fixed-columns-master/bootstrap-table-fixed-columns.css'

import Notyf from "notyf";
window.notyf = new Notyf({
  delay: 3000
});

import echarts from "echarts";
window.echarts = echarts;

import "./assets/less/global.less";

import MyUtil from "./assets/js/class_util";
window.myutil = new MyUtil();

import MyFilter from "./assets/js/class_filter";
window.myfilter = new MyFilter();
myfilter.init();

import Vant from 'vant';
import 'vant/lib/index.css';

import "../static/charting_library/charting_library.standalone.js";

Vue.use(Vant);

// 省市联动
import "distpicker";
$.fn.distpicker.setDefaults({
  placeholder: false
});

// input 时间
import "bootstrap-datepicker";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.zh-CN.min.js";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";

import store from "./store";

Vue.config.productionTip = false;



import i18n from './i18n/';


/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js